import intance from "../request"

//对话接口
export function dialog(question,nonce_str){
    let url = "/api/search/"
    return intance.post(url,{
        question,
        nonce_str
    })
}

//满意率接口（未解决）
export function unsolved(id){
    let url = "/api/like/logs/" + id + "/"
    return intance.put(url)
}

//昵称接口
export function setting(key){
    let url = '/api/settings/'
    return intance.get(url,{
        params:{
            key
        }
    })
}

//昵称接口
export function getQuestions(){
    let url = '/api/knlgbases/qas/?sort=qid_desc&&page=1&&page_size=5&&samples=open'
    return intance.get(url)
}

export function sendMsg(question){
    let url = "/chat"
    return intance.post(url, question)
}